import { SyslogLevel } from './loggerTypes'
import type { LogEntry } from './loggerTypes'

// Map syslog level (0-7) to OTel Severity Number
export function mapSyslogToOtelSeverity(syslogLevel: SyslogLevel): number {
  switch (syslogLevel) {
    case SyslogLevel.emerg: return 22 // FATAL2
    case SyslogLevel.alert: return 21 // FATAL
    case SyslogLevel.crit: return 20  // ERROR4
    case SyslogLevel.error: return 17 // ERROR
    case SyslogLevel.warning: return 13 // WARN
    case SyslogLevel.notice: return 10 // INFO2
    case SyslogLevel.info: return 9   // INFO
    case SyslogLevel.debug: return 5  // DEBUG
    default: return 9 // INFO
  }
}

// Convert Syslog string equivalent for OTel
export function mapSyslogToOtelSeverityText(syslogLevel: SyslogLevel): string {
  if (syslogLevel === SyslogLevel.warning) return 'WARNING'
  const entry = Object.entries(SyslogLevel).find(([, val]) => val === syslogLevel)
  return entry ? entry[0].toUpperCase() : 'UNKNOWN'
}

export function mapLogEntryToOtelFormat(entry: LogEntry) {
  const severityNumber = mapSyslogToOtelSeverity(entry.logLevel)
  const severityText = mapSyslogToOtelSeverityText(entry.logLevel)
  
  const attributes: Record<string, unknown> = {
    'log.module': entry.module,
    'log.component': entry.component,
  }

  if (entry.commonInfo) {
    for (const [k, v] of Object.entries(entry.commonInfo)) {
      if (v !== undefined) {
        attributes[`common.${k}`] = v
      }
    }
  }

  let body = entry.message
  
  if (entry.data !== undefined && entry.data !== null) {
    if (entry.data instanceof Error) {
      attributes['exception.message'] = entry.data.message
      attributes['exception.stacktrace'] = entry.data.stack
      attributes['exception.type'] = entry.data.name
    } else if (typeof entry.data === 'object' && !Array.isArray(entry.data)) {
      for (const [k, v] of Object.entries(entry.data as Record<string, unknown>)) {
        attributes[`data.${k}`] = (typeof v === 'object' && v !== null ? JSON.stringify(v) : v)
      }
    } else {
      attributes['data.raw'] = typeof entry.data === 'string' ? entry.data : JSON.stringify(entry.data)
    }
  }

  // OTel Timestamp usually takes a Date, or a high precision number. We pass Date.
  return {
    timestamp: new Date(entry.ts),
    severityNumber,
    severityText,
    body,
    attributes
  }
}
